/* The Past Menus search and "Show older weeks" (2026-09-15).
 *
 * Heidi: "add a search bar on this page so customers can quickly find a dish
 * they're looking for". sections/maven-past-menus.liquid renders every week, so
 * this script only shows and hides rows that are already on the page. It sends
 * no request.
 *
 * A query matches a dish when every word of the query is in the dish title.
 * Case, accents and punctuation do not count. Neither do the joining words
 * "and", "with" and "the": a title spells the same dish "Black Bean Mango
 * Salad", "Black Bean & Mango" or "Black Bean and Mango", so a query that
 * says "and" must still find all three (measured on the trial store,
 * 2026-09-15: "black bean and mango" found nothing).
 *
 * While a query is active:
 *   - a row that does not match is hidden;
 *   - a week with no matching row is hidden, older weeks included;
 *   - a week with a match opens, so a row below the first ones is visible;
 * Clearing the query puts every row, week and disclosure back as it was.
 *
 * ⚠️ THE ROW AND WEEK LIMITS ARE CSS, AND THIS SCRIPT OWNS THE EXCEPTIONS.
 * assets/maven-past-menus.css hides `.mv-pm__dish--extra` in a week, and below
 * 750px it hides the fifth dish onward and the seventh week onward, because a
 * phone limit has to be a media query and a Liquid `limit` cannot know the
 * width. Three attributes lift those rules:
 *
 *   data-mv-pm-js        on the section. Nothing is hidden without it, so a
 *                        reader with no script sees every dish and every week.
 *   data-mv-pm-all       on the grid. Show older weeks, or any search.
 *   data-mv-pm-expanded  on a week. Its own Show all button, or a search that
 *                        matched inside it.
 *
 * ⚠️ A ROW, A WEEK AND A BUTTON ARE HIDDEN WITH THE `hidden` ATTRIBUTE, AND
 * EACH ONE NEEDS A `[hidden] { display: none }` RULE IN THE STYLESHEET. The
 * rows are flex and the button is flex, and an author `display` beats the
 * browser's own [hidden] rule. assets/maven-menu.css records the same trap. */
(function () {
  'use strict';

  var JOINING_WORDS = Object.create(null);
  JOINING_WORDS.and = JOINING_WORDS.with = JOINING_WORDS.the = true;

  function normalise(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function init(root) {
    var search = root.querySelector('[data-mv-pm-search]');
    var input = root.querySelector('[data-mv-pm-input]');
    var status = root.querySelector('[data-mv-pm-status]');
    var weeks = Array.prototype.slice.call(root.querySelectorAll('[data-mv-pm-week]'));
    var olderToggle = root.querySelector('[data-mv-pm-older-toggle]');
    var grid = root.querySelector('[data-mv-pm-grid]');
    var olderShown = false;

    if (!weeks.length) return;

    /* Index once. A week keeps its rows, its disclosure, and whether it is an
       older week, so a cleared query can restore the page exactly. */
    var index = weeks.map(function (week) {
      var more = week.querySelector('[data-mv-pm-more]');
      if (more) more.hidden = false;
      return {
        el: week,
        older: week.hasAttribute('data-mv-pm-older'),
        more: more,
        moreLabel: more ? more.textContent.trim() : '',
        rows: Array.prototype.slice.call(week.querySelectorAll('.mv-pm__dish')).map(function (row) {
          var link = row.querySelector('.mv-pm__dish-link');
          return { el: row, text: normalise(link ? link.textContent : row.textContent) };
        })
      };
    });

    function setOlder(show) {
      olderShown = show;
      index.forEach(function (w) {
        if (w.older) w.el.hidden = !show;
      });
      if (grid) grid.toggleAttribute('data-mv-pm-all', show);
      if (olderToggle) {
        olderToggle.setAttribute('aria-expanded', show ? 'true' : 'false');
        olderToggle.textContent = show ? 'Show fewer weeks' : 'Show older weeks';
      }
    }

    function setWeekOpen(w, open) {
      w.el.toggleAttribute('data-mv-pm-expanded', open);
      if (w.more) {
        w.more.setAttribute('aria-expanded', open ? 'true' : 'false');
        w.more.textContent = open ? 'Show fewer dishes' : w.moreLabel;
      }
    }

    function reset() {
      index.forEach(function (w) {
        w.rows.forEach(function (r) { r.el.hidden = false; });
        setWeekOpen(w, false);
        /* The search hides a week's own button; give it back. */
        if (w.more) w.more.hidden = false;
        w.el.hidden = w.older && !olderShown;
      });
      if (grid) grid.toggleAttribute('data-mv-pm-all', olderShown);
      if (olderToggle) olderToggle.parentElement.hidden = false;
      if (status) status.textContent = '';
    }

    function apply(query) {
      var terms = normalise(query).split(' ').filter(function (t) {
        return t && !JOINING_WORDS[t];
      });
      if (!terms.length) {
        reset();
        return;
      }

      var dishCount = 0;
      var weekCount = 0;

      index.forEach(function (w) {
        var inWeek = 0;
        w.rows.forEach(function (r) {
          var match = terms.every(function (t) { return r.text.indexOf(t) !== -1; });
          r.el.hidden = !match;
          if (match) inWeek += 1;
        });
        w.el.hidden = inWeek === 0;
        /* Every matching row shows, wherever it sits in the list, and the
           week's own button has nothing to add while a search is running. */
        setWeekOpen(w, inWeek > 0);
        if (w.more) w.more.hidden = inWeek > 0;
        if (inWeek > 0) {
          weekCount += 1;
          dishCount += inWeek;
        }
      });

      /* The older-weeks button means nothing while a search spans every week,
         and the grid attribute lifts the phone's six-week limit. */
      if (olderToggle) olderToggle.parentElement.hidden = true;
      if (grid) grid.setAttribute('data-mv-pm-all', '');

      if (status) {
        status.textContent = dishCount === 0
          ? 'No past dishes match "' + query.trim() + '".'
          : dishCount + (dishCount === 1 ? ' dish' : ' dishes') + ' in ' +
            weekCount + (weekCount === 1 ? ' week' : ' weeks');
      }
    }

    var timer = null;
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { apply(input.value); }, 120);
      });
      /* Enter on a phone keyboard submits nothing here; keep the page put. */
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') e.preventDefault();
        if (e.key === 'Escape') {
          input.value = '';
          apply('');
        }
      });
    }

    if (olderToggle) {
      olderToggle.addEventListener('click', function () { setOlder(!olderShown); });
    }

    index.forEach(function (w) {
      if (!w.more) return;
      w.more.addEventListener('click', function () {
        setWeekOpen(w, !w.el.hasAttribute('data-mv-pm-expanded'));
      });
    });

    /* Nothing is hidden until the script says so. */
    root.setAttribute('data-mv-pm-js', '');

    /* The search box renders hidden, so a page without this script never
       shows a box that does nothing. */
    if (search) search.hidden = false;
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.mv-pm'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
